import { AnalysisIssuePersonSingleEventConflict } from '@hefe/models';
import IssueEventBlockComponent from '../issue-event-block/issue-event-block.component';
import IssueUserBlockComponent from '../issue-user-block/issue-user-block.component';

interface IssuePersonSingleEventConflictBodyComponentProps {
  issue: AnalysisIssuePersonSingleEventConflict;
}

export default function IssuePersonSingleEventConflictBodyComponent(
  props: IssuePersonSingleEventConflictBodyComponentProps
) {
  const { issue } = props;
  return (
    <>
      <IssueUserBlockComponent user={issue.context.user} />
      <IssueEventBlockComponent event={issue.context.event} />
    </>
  );
}
